import { render } from "./BatchIssue.vue?vue&type=template&id=4aaa81e2&scoped=true"
import script from "./BatchIssue.vue?vue&type=script&lang=js"
export * from "./BatchIssue.vue?vue&type=script&lang=js"

import "./BatchIssue.vue?vue&type=style&index=0&id=4aaa81e2&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3624/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aaa81e2"]])

export default __exports__